import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AuthorBlock from '../../../components/User/AuthorBlock';
import ForumAttachList from '../../Forum/ForumAttachList';

export default class PracticeDetailForumComment extends Component {
  static propTypes = {
    comment: PropTypes.shape({
      id: PropTypes.number.isRequired,
      userId: PropTypes.string.isRequired,
      createDate: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      attachments: PropTypes.array,
    }).isRequired,
  };

  render() {
    const { comment } = this.props;
    return (
      <div className="list-themes-item">
        <div className="list-themes-author">
          <AuthorBlock
            user={comment.user}
            dateFormat="full"
            createDate={comment.createDate}
            className=""
          />
        </div>

        <div className="list-themes-desc">
          <div className="post-content__text wysiwyg" dangerouslySetInnerHTML={{ __html: comment.text }}></div>

          {comment.attachments && comment.attachments.length ? <ForumAttachList attachments={comment.attachments} /> : ''}
        </div>
      </div>
    );
  }
}
